<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="website && website.id">{{ 'WEBSITE.WEBSITE_FORM.EDIT' | translate }}</span>
    <span *ngIf="!website || !website.id">{{ 'WEBSITE.WEBSITE_FORM.ADD' | translate }}</span>
  </h4>
  <button type="button" class="close btn-close-templates" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="website-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="row">
      <div class="col-sm-4">
        <div class="form-group">
          <app-company-select [parentFormGroup]="form"></app-company-select>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="form-group">
          <label>{{ 'WEBSITE.WEBSITE_FORM.WEBSITE_NAME' | translate }}</label>
          <input type="text" class="form-control" formControlName="name" />
        </div>
      </div>
      <div class="col-sm-4">
        <div class="form-group">
          <label>{{ 'WEBSITE.WEBSITE_FORM.URL' | translate }}</label>
          <input type="text" class="form-control" formControlName="url" />
        </div>
      </div>

      <div class="col-sm-2">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" formControlName="active" id="website-active" />
          <label class="custom-control-label" for="website-active">
            {{ 'WEBSITE.WEBSITE_FORM.ACTIVE' | translate }}
          </label>
        </div>
      </div>
      <div class="col-sm-10">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" formControlName="webhook_active" id="webhook-active" />
          <label class="custom-control-label" for="webhook-active">
            {{ 'WEBSITE.WEBSITE_FORM.WEBHOOK_ACTIVE' | translate }}
          </label>
        </div>
      </div>

      <div class="col-sm-6" *ngIf="form.get('webhook_active').value">
        <div class="form-group">
          <label>{{ 'WEBSITE.WEBSITE_FORM.WEBHOOK_URL' | translate }}</label>
          <input type="text" class="form-control" formControlName="webhook_url" />
        </div>
      </div>
      <div class="col-sm-6" *ngIf="form.get('webhook_active').value">
        <div class="form-group">
          <label>{{ 'WEBSITE.WEBSITE_FORM.WEBHOOK_SECRET' | translate }}</label>
          <input type="text" class="form-control" formControlName="webhook_secret" />
        </div>
      </div>
    </div>

    <div formArrayName="locales" class="locales-wrapper">
      <div class="row">
        <div *ngFor="let locale of form.get('locales')?.controls; let i = index" class="col-sm-3">
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              [attr.id]="'permission' + '-' + locale.get('id').value"
              [formControl]="locale.get('selected')"
            />
            <label class="custom-control-label" [attr.for]="'permission' + '-' + locale.get('id').value">
              <span class="flag-icon" [ngClass]="'flag-icon-' + locale.get('locale').value"></span>
              {{ locale.get('name').value }}
            </label>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="website-form" [disabled]="form.invalid">
    {{ 'WEBSITE.WEBSITE_FORM.SAVE' | translate }}
  </button>
</div>
